import { render, staticRenderFns } from "./OutliersChart.vue?vue&type=template&id=2a1bf0ec"
import script from "./OutliersChart.vue?vue&type=script&lang=js"
export * from "./OutliersChart.vue?vue&type=script&lang=js"
import style0 from "./OutliersChart.vue?vue&type=style&index=0&id=2a1bf0ec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports